var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilitaryId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-landscape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 5H11C9.34315 5 8 6.67893 8 8.75V31.25C8 33.3211 9.34315 35 11 35H29C30.6569 35 32 33.3211 32 31.25V8.75C32 6.67893 30.6569 5 29 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.685 15H17.185V16.5C17.185 17.2956 17.5011 18.0587 18.0637 18.6213C18.6263 19.1839 19.3893 19.5 20.185 19.5C20.9806 19.5 21.7437 19.1839 22.3063 18.6213C22.8689 18.0587 23.185 17.2956 23.185 16.5V15",
    stroke: "#5F738C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 27.0645C14 25.4561 14.6391 23.9136 15.7766 22.7762C16.9142 21.6389 18.457 21 20.0657 21C21.6745 21 23.2173 21.6389 24.3549 22.7762C25.4924 23.9136 26.1315 25.4561 26.1315 27.0645H14Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.185 15H17.185L16.435 12L23.935 12.75L23.185 15Z",
    stroke: "#5F738C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitaryId);
export default __webpack_public_path__ + "static/media/military_id.b2269c31adfc32b35f9fd1c2238efca8.svg";
export { ForwardRef as ReactComponent };